import React from 'react';
import { FaCheck } from 'react-icons/fa';

const ProgressIndicator = ({ current, total, progress, responses, onQuestionClick }) => {
    const getQuestionStatus = (questionIndex) => {
        const questionId = questionIndex + 1;
        return responses[questionId] ? 'completed' : questionIndex === current - 1 ? 'current' : 'pending';
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'completed':
                return 'bg-green-500 text-white';
            case 'current':
                return 'bg-blue-500 text-white';
            case 'pending':
                return 'bg-gray-200 text-gray-500';
            default:
                return 'bg-gray-200 text-gray-500';
        }
    };

    return (
        <div className="mb-6">
            {/* Progress Bar */}
            <div className="mb-4">
                <div className="flex justify-between items-center mb-2">
                    <span className="text-sm font-medium text-gray-700">
                        Progreso del cuestionario
                    </span>
                    <span className="text-sm text-gray-500">
                        {Math.round(progress)}%
                    </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                        className="bg-blue-500 h-2 rounded-full transition-all duration-300"
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
            </div>

            {/* Question Dots */}
            <div className="flex justify-center space-x-2">
                {Array.from({ length: total }, (_, index) => {
                    const status = getQuestionStatus(index);
                    const isClickable = status === 'completed' || index === current - 1;

                    return (
                        <button
                            key={index}
                            onClick={() => isClickable && onQuestionClick(index)}
                            disabled={!isClickable}
                            className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium transition-all duration-200 ${isClickable ? 'cursor-pointer hover:scale-110' : 'cursor-not-allowed'
                                } ${getStatusColor(status)}`}
                            title={`Pregunta ${index + 1}`}
                        >
                            {status === 'completed' ? (
                                <FaCheck className="w-3 h-3" />
                            ) : (
                                index + 1
                            )}
                        </button>
                    );
                })}
            </div>

            {/* Progress Text */}
            <div className="text-center mt-3">
                <span className="text-sm text-gray-600">
                    {current} de {total} preguntas
                </span>
                {Object.keys(responses).length > 0 && (
                    <span className="text-sm text-green-600 ml-2">
                        • {Object.keys(responses).length} respondidas
                    </span>
                )}
            </div>
        </div>
    );
};

export default ProgressIndicator; 